
<template>
	<div class="content-i">
		<div>
    	<div class="content-box" style="padding-top: 10px;">
        <div class="element-wrapper">
					<h6 class="element-header">{{ t('titleManageAdminLogins','titleManageAdminLogins') }}</h6>						
          <div class="element-box">		
						<div class="element-info">
							<div class="row">
								<div class="col-12 col-sm-6 col-md-8">
									<div class="element-info-with-icon">
										<div class="element-info-icon">
											<span class="os-icon os-icon-search2"></span>
										</div>
										<div class="element-info-text">
											<h5 class="element-inner-header">{{ t('headerManageAdminUsersSearch','headerManageAdminUsersSearch') }}</h5>
											<div class="element-inner-desc">{{ t('manageAdminUsersFormDesc', 'manageAdminUsersFormDesc') }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>										
            <div class="element-box-tp">
							<div class="row">
                <div class="col-6">
                  <div class="row block-input-row">
                    <div class="col-6">
                      <span>{{ t('manageAdminLoginEmailSearchLabel', 'manageAdminLoginEmailSearchLabel') }}</span>
                      <input class="form-control" v-model="searchedEmail" type="text">
                    </div>
                  </div>
                  <!-- NS-9847, extra filter, PW -->
                  <div class="row block-input-row">
                    <div class="col-6">
                      <span>{{ t('manageAdminLoginUserLevelSearchLabel', 'manageAdminLoginUserLevelSearchLabel') }}</span>
                      <select class="form-control" v-model="searchedUserLevel" v-if="userLevelsFilter">
                        <option value="all">{{ t('allUserLevelsText', 'allUserLevelsText') }}</option>
                        <option v-for="userLevel in userLevelsFilter.userLevels" :value="userLevel.value" :key="userLevel.value">{{ userLevel.text }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6 px-0 text-left mt-2">
                    <button class="btn btn-primary" @click="requestAdminUsersList()">Search</button>
                  </div>
                </div>
								<div class="col-12 text-left mt-2">
									<button v-if="!isBusy" class="btn btn-success" v-on:click="openAddModal(t('addAdminUserModalTitle', 'addAdminUserModalTitle'), $event.target)">{{ t('addAdminUserBtn','addAdminUserBtn') }}</button>
								</div>
							</div>							
              <div class="controls-below-table">
								<div class="col-sm-12 col-md-6 table-records-info px-0" v-if="getAdminUsers.data">
									<p class="mb-0">{{ totalRows }} {{ t('endUsersListEntriesFound','endUsersListEntriesFound') }}</p>
								</div>
								<div class="col-sm-12 col-md-4" v-if="getAdminUsers.data">
									<b-pagination class="float-right mb-0" v-model="currentPage" v-if="totalRows > 0" :total-rows="totalRows" :per-page="perPage" aria-controls="logs-table">
									</b-pagination>
								</div>
								<div class="col-sm-12 col-md-2 px-0">
									<b-input-group class="form-group col-lg-12 mb-0 px-0">
										<b-input-group-prepend>
											<label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
										</b-input-group-prepend>
										<b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
									</b-input-group>
								</div>
              </div>				
							<transition name="fade">
								<ResponseInfo v-if="getResponseInfo.responseName == 'manageAdminUsers'" class="mt-2"/>			
							</transition>
              <div class="table-responsive" v-if="getAdminUsers">
								<b-table id="logs-table" striped hover bordered class="mt-3" :busy.sync="isBusy" v-if="getAdminUsers.data" :items="getAdminUsers.data" :fields="fields" :total-rows="totalRows" :per-page="0" :currentPage="currentPage" :show-empty="rowEmpty">
									<template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="data.item">
                    <vcl-table :rows="parseInt(perPage)" :columns="5"></vcl-table>
                  </template>
                  <template v-slot:head(adminName)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(adminEmail)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
									<template v-slot:head(adminLevel)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>									
                  <template v-slot:head(adminOperations)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(adminAccountStatusToggle)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>									
									<!-- tbody -->
									<template v-slot:cell(adminName)="data">
                    <span >{{ data.item.name }}</span>
                  </template>
                  <template v-slot:cell(adminEmail)="data">
                    <span >{{ data.item.email }}</span>
                  </template>
									<template v-slot:cell(adminLevel)="data">
                    <span >{{ data.item.level }}</span>
                  </template>
                  <template v-slot:cell(adminOperations)="data">										
										<b-link v-if="data.item.email_protected == 0 || getUserDetails.level > 2.00" class="px-1" href="#" @click="openEditModal(t('editAdminUserDetailsModalTitle', 'editAdminUserDetailsModalTitle'), data.item.id, data.item.level_code, data.item.name, data.item.email, data.item.password, data.item.email_protected, data.item.head_user, data.item.pan_principal_access, data.item.hash_logon, $event.target)">
											Edit
										</b-link>
										<b-link v-if="data.item.email_protected == 0 || getUserDetails.level > 2.00" class="px-1" href="#" @click="openEditPrincipalsModal(data.item.id, t('editAdminUserPrincipalsModalTitle', 'editAdminUserPrincipalsModalTitle'), $event.target)">
											Edit User {{principleTerms}}
										</b-link>
										<b-link v-if="data.item.email_protected == 0 && data.item.level_code < getUserDetails.level" class="px-1" href="#" @click="openEditDocTypesModal( data.item.id, t('editAdminUserDocTypesModalTitle', 'editAdminUserDocTypesModalTitle'), $event.target)">
											Edit Document Types
										</b-link>																				
										<b-link class="px-1" v-if="getUserLevel >= 2.00 && data.item.level != 'Newsnet'" href="#" @click="modalCreator({id: 'ModalSendLoginDetails', title: t('sendEmailAdminUserModalTitle', 'sendEmailAdminUserModalTitle'), userId: data.item.id, email: data.item.email, password: data.item.password}, $event.target)">
											Email
										</b-link>
										<b-link v-if="displayDeleteLink(data)" class="px-1" href="#" @click="openDeleteModal(t('deleteAdminUserModalTitle', 'deleteAdminUserModalTitle'), data.item.id, data.item.email, $event.target)">
											Delete
										</b-link>
                  </template>
									<template v-slot:cell(adminAccountStatusToggle)="data">
										<toggle-button @change="editAccountStatus($event, data.item)" :value="Boolean(!data.item.account_disabled)" :font-size="15" :height="30" :width="95" :color="{checked: '#008000', unchecked: '#B22222'}" :sync="true" :labels="{checked: 'Active', unchecked: 'Inactive'}"/>
									</template>
								</b-table>
							</div>
              <div class="controls-below-table pt-4">
								<div class="col-sm-12 col-md-6 table-records-info" v-if="getAdminUsers.data">
									<p>{{ totalRows }} {{ t('endUsersListEntriesFound','endUsersListEntriesFound') }}</p>
								</div>
								<div class="col-sm-12 col-md-4" v-if="getAdminUsers.data">
									<b-pagination class="float-right mb-0" v-model="currentPage" v-if="totalRows > 0" :total-rows="totalRows" :per-page="perPage" aria-controls="logs-table">
									</b-pagination>
								</div>
								<div class="col-sm-12 col-md-2 px-0">
									<b-input-group class="form-group col-lg-12 px-0 mb-0">
										<b-input-group-prepend>
											<label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
										</b-input-group-prepend>
										<b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
									</b-input-group>
								</div>
              </div>							
						</div>			
					</div>
				</div>
			</div>
		</div>
		<!-- ADD MODAL -->
		<b-modal class="modal-lg" :id="addModal.id" :title="addModal.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetaddModal()">
			<template slot="modal-header" slot-scope="{ close }">
				<h5 v-if="!userExists" class="modal-title text-light">{{ addModal.title }}</h5>
				<h5 v-else class="modal-title text-light">{{ t('updateAdminUserModalTitle','updateAdminUserModalTitle') }}</h5>
				<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
			</template>
			<template v-if="!userExists" slot="default">
				<div class="row modal-body-log">
					<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('userNameLabelText', 'userNameLabelText') }}*</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="email_address" v-model="addModal.userName"></b-form-input>
						</b-input-group>									
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('realNameLabelText', 'realNameLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="real_name" v-model="addModal.name"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('emailLabelText', 'emailLabelText') }}*</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="email_address" v-model="addModal.email"></b-form-input>
						</b-input-group>						
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('passwordLabelText', 'passwordLabelText') }}*</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="user_password" v-model="addModal.password" :type="'password'"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('headUserLabelText', 'headUserLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-select :disabled="getUserLevel < 2.00" v-model="addModal.headUser" :options="headUserAndProtectedOptions" value-field="value" text-field="text"></b-form-select>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('userLevelLabelText', 'userLevelLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-select v-model="addModal.userLevel" :options="getAvailableUserLevls" value-field="value" text-field="text"></b-form-select>
						</b-input-group>																																									
					</b-form-group>
				</div>
			</template>
			<template v-else class="row modal-body-log">
				<div class="row modal-body-log">
					<div class="col-lg-12 py-2"><span class="">{{ t('adminUserAlreadyExistModalText','adminUserAlreadyExistModalText') }}</span></div>
					<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('userNameLabelText', 'userNameLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="email_address" :disabled="true" v-model="existingUserDetails.username"></b-form-input>
						</b-input-group>									
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('realNameLabelText', 'realNameLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="real_name" :disabled="true" v-model="existingUserDetails.name"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('emailLabelText', 'emailLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="email_address" :disabled="true" v-model="existingUserDetails.email"></b-form-input>
						</b-input-group>						
					</b-form-group>
					<div class="col-lg-12 py-2"><span class="">{{ t('changeAdminUserAccessLevelQuestion','changeAdminUserAccessLevelQuestion') }}</span><span> {{addModal.userLevel}} ?</span></div>
					<div class="col-lg-12 py-2"><span class="">{{ t('AdminUserPasswordWillnotChangeText','AdminUserPasswordWillnotChangeText') }}</span></div>		
				</div>
			</template>		
			<template slot="modal-footer" slot-scope="{ close }">
				<button type="button" class="btn btn-secondary" @click="close()">Cancel</button>
				<button v-if="!userExists" type="button" class="btn btn-primary" :disabled="!addModal.email || !addModal.password || !addModal.userName" @click="addAdminUser()">add</button>
				<button v-else type="button" class="btn btn-primary" @click="updateAdminUser()">Update</button>
			</template>
			<ValidationErrors class="p-1" v-if="getValidationErrors.validationName == 'adminUserError'"></ValidationErrors>
		</b-modal>
		<!-- EDIT MODAL -->
		<b-modal class="modal-lg" :id="editModal.id" :title="editModal.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetEditModal()">
			<template slot="modal-header" slot-scope="{ close }">
				<h5 class="modal-title text-light">{{ editModal.title }}</h5>
				<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
			</template>
			<template slot="default">
				<div class="row modal-body-log">
					<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('realNameLabelText', 'realNameLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="real_name" v-model="editModal.name"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('emailLabelText', 'emailLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="email_address" v-model="editModal.email"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('passwordLabelText', 'passwordLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input :disabled="getUserDetails.id != editModal.userId && getUserLevel == editModal.level" id="user_password" v-model="editModal.password" :type="'password'"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('headUserLabelText', 'headUserLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-select :disabled="getUserLevel < 2.00" v-model="editModal.headUser" :options="headUserAndProtectedOptions" value-field="value" text-field="text"></b-form-select>
						</b-input-group>
						<b-input-group v-if="protectedUserEnabled == '1'" class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('protectedUserLabelText', 'protectedUserLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-select v-model="editModal.protectedUser" :options="headUserAndProtectedOptions" value-field="value" text-field="text"></b-form-select>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('userLevelLabelText', 'userLevelLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-select :disabled="getUserDetails.id != editModal.userId && getUserLevel == editModal.level" v-model="editModal.level" :options="getAvailableUserLevls" value-field="value" text-field="text"></b-form-select>
						</b-input-group>						
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('hashAuthenticationLabelText', 'hashAuthenticationLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-select v-model="editModal.hashLogon" :options="userHashLogonOptions" value-field="value" text-field="text"></b-form-select>
						</b-input-group>
						<div class="col-lg-12 py-1">
							<span class="pretext-span tips-font-size">if hash logon is enabled and this box is ticked the emails sent to the user will be allowed to use the variable "[HASH]". By default "[HASH]" return an empty string.</span>
						</div>																																																		
					</b-form-group>
				</div>
			</template>
			<template slot="modal-footer" slot-scope="{ close }">
				<button type="button" class="btn btn-secondary" @click="close()">Cancel</button>
				<button type="button" class="btn btn-primary" @click="editAdminUser()">Update</button>
			</template>
			<ValidationErrors class="p-1" v-if="getValidationErrors.validationName == 'adminUserError'"></ValidationErrors>
		</b-modal>
		<!-- DELETE MODAL -->
		<b-modal class="modal-lg" :id="deleteModal.id" :title="deleteModal.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="resetDeleteModal()">
			<template slot="modal-header" slot-scope="{ close }">
				<h5 class="modal-title text-light">{{ deleteModal.title }} ?</h5>
				<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
			</template>
			<template slot="default">
					<div class="row modal-body-log">                   
						<div v-if="!(deleteModal.userId === undefined)" class="col-lg-12 py-2"><span class="">{{ t('deleteAdminUserModalQuestion','deleteAdminUserModalQuestion') }} </span> <span class="font-weight-bold">"{{ deleteModal.email }}"? </span></div>                     
					</div>
			</template>
			<template slot="modal-footer" slot-scope="{ close }">
				<button type="button" class="btn btn-secondary" @click="close()">Cancel</button>
				<button type="button" class="btn btn-primary" @click="deleteAdminUser()">Yes</button>
			</template>
		</b-modal>			
		<div v-if="overlayBackgroundDisplay" class="modal-backdrop show"></div>
		<ModalSendLoginDetails :modal="this.modal"/>
		<ModalEditPrincipals :modal="this.editPrincipalsModal" @hide="resetEditPrincipalsModal"/>
		<ModalEditDocTypes :modal="this.editDocTypesModal" @hide="resetEditDocTypesModal"/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'
import { VclTable } from 'vue-content-loading'
import ModalSendLoginDetails from '@/components/Manage_Users/ModalSendLoginDetails.vue'
import ModalEditPrincipals from '@/components/Manage_Users/ModalEditPrincipals.vue'
import ModalEditDocTypes from '@/components/Manage_Users/ModalEditDocTypes.vue'

export default {
	name: 'ManageAdminLoginsView',
	components: {
		ResponseInfo,
		ValidationErrors,
		VclTable,
		ModalSendLoginDetails,
		ModalEditPrincipals,
		ModalEditDocTypes
	},
	provide() {
		return {
			resetModal: this.resetModal
		}
	},
	data() {
		return {
			isBusy: false,			
			pageOptions: [10, 20, 50, 100],
			currentPage: 1,
			perPage: 20,
			totalRows: 0,
			rowEmpty: false,
			protectedUser: null,
			activation: '',
			userExists: false,
			existingUserDetails: null,
      overlayBackgroundDisplay: false,
      searchedEmail: null,
      searchedUserLevel: null,
			userLevelsFilter: null,
			docViewAccessService: false, // NS-10020 SP
			principleTerms: '', // NS-10020 SP
			endUsersListRequest: {	
				customer_reference: this.$route.query.customer_reference ? this.$route.query.customer_reference : '',
				customer_name: this.$route.query.customer_name ? this.$route.query.customer_name : '',
				user_email: this.$route.query.user_email ? this.$route.query.user_email : '',
				user_name: this.$route.query.user_name ? this.$route.query.user_name : '',
				user_protected: this.$route.query.user_protected ? this.$route.query.user_protected : 0,
			},
			fields: [
				{key: 'adminName', label: 'adminsTableNameLabel', sortable: true, thClass: 'showhand brand-color', tdClas: 'text-center'},
				{key: 'adminEmail', label: 'adminsTableEmailLabel', thClass: 'showhand brand-color', tdClas: 'text-center'},
				{key: 'adminLevel', label: 'adminsTableLevelLabel', thClass: 'showhand brand-color', tdClass: 'text-center'},
				{key: 'adminOperations', label: 'adminsTableOperationsLabel', thClass: 'showhand brand-color'},
				{key: 'adminAccountStatusToggle', label: 'adminsTableAccountStatusToggle', thClass: 'brand-color', tdClass: 'text-center'}
			],
      modal: {
        modalData: {},
        updateData: {}
      },			
			addModal: {
				id: 'add-modal-adminUsers',
				title: '',
				userId: null,
				userName: '',
				name: '',
				email: '',
				password: '',
				userLevel: null,
				headUser: 0,
			},
			editModal: {
				id: 'edit-modal-adminUser',
				title: '',
				level: '',
				userId: null,
				name: '',
				email: '',
				password: '',
				protectedUser: 0,
				headUser: 0,
				panPrincipalAccess: 0, // NS-10020 SP
				hasLogon: 0
			},	
			emailModal: {
				id: 'email-modal-adminUser',
				userId: null,
				title: '',
				sendTo: '',
				subject: '',
				from: '',
				message: '',
				password: ''
			},
			deleteModal: {
				id: 'delete-modal-adminUser',
				title: '',
				userId: null,
				email: ''
			},				
			headUserAndProtectedOptions: [
				{ value: 0, text: 'no'},
				{ value: 1, text: 'yes'}
			],
			userHashLogonOptions: [
				{ value: 0, text: 'disabled'},
				{ value: 1, text: 'enabled'}
			],
      editPrincipalsModal: {
        id: 'edit-principals-modal-adminUser',
        title: '',
        userId: null,
        principals: null
      },
      editDocTypesModal: {
        id: 'edit-doc-types-modal-adminUser',
        title: '',
        userId: null,
        docTypes: null
      }
		}
	},
	created() {
		this.getDocViewAccessServiceAndPrincipleTerm() // NS-10020 get the doc view access when the page created 
    this.requestAdminUsersList()
    this.getUserLevelFilters()
    this.$store.dispatch('endUsersAdminLogonsStore/getProtectedUser').then(() => {
      this.protectedUser = this.$store.getters['endUsersAdminLogonsStore/getProtectedUser']
    }, this)
  },
	methods: {
		requestAdminUsersList() {
			this.isBusy = true
      this.$router.push({ query: { page: this.currentPage, per_page: this.perPage }})

      // NS-9847, extra user level parameter for filtering, PW
      if(this.searchedEmail && this.searchedEmail != '') {
        this.$router.push({ query: Object.assign({}, this.$route.query, { email: this.searchedEmail })})
      }

      if(this.searchedUserLevel) {
        this.$router.push({ query: Object.assign({}, this.$route.query, { userLevel: this.searchedUserLevel })})
      }

			this.$store.dispatch('endUsersAdminLogonsStore/getAdminUsersList', {
				currentUserLevel: this.$store.getters.getUserLevel,
				page: this.currentPage,
        per_page: this.perPage,
        email: this.searchedEmail,
        userLevel: this.searchedUserLevel
			}).then(() => {
				this.isBusy = false
				this.totalRows = this.getAdminUsers.total

        if(this.totalRows == 0) {
          this.rowEmpty = true
        } else {
          this.rowEmpty = false
        }
			})
		},
		// NS-10020 get Document view access for client
		getDocViewAccessServiceAndPrincipleTerm() {
			this.$store.dispatch('endUsersAdminLogonsStore/getDocViewAccessServiceAndPrincipleTerm').then(response => {
				this.docViewAccessService = response.documentViewAccess
				this.principleTerms = response.principleTerms
			})
		},
		modalCreator(modalData, button) { 
			switch(modalData.id) {
				case 'ModalSendLoginDetails':
					this.$store.dispatch('endUsersAdminLogonsStore/getEndUserEmailDetails', {
					id: modalData.userId 
					}).then(() => {
						this.modal.modalData = this.$store.getters['endUsersAdminLogonsStore/getEmailForm']
						this.modal.modalData.title = modalData.title
						this.modal.modalData.userId = modalData.userId
						this.modal.modalData.component = 'adminUsers'
						this.$root.$emit('bv::show::modal', modalData.id, button)
					})
					break
				default:
					this.modal.modalData = modalData
					this.$root.$emit('bv::show::modal', this.modal.modalData.id, button)
					break
			}
			this.overlayBackgroundDisplay = true
		},
    resetModal(level, button = '') {
      if(level == 'main') {
        Object.keys(this.modal['modalData']).forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
				Object.keys(this.modal['updateData']).forEach((key) => (this.modal['updateData'][key] = '' ))
				this.overlayBackgroundDisplay = false
        //this.$store.dispatch('alertClearResponse')
			}
		},		
		openAddModal(title, button) {
			this.$store.dispatch('endUsersAdminLogonsStore/getAddAdminUserData', {
				userLevel: this.$store.getters.getUserLevel
			}).then(() => {
				this.$root.$emit('bv::show::modal', this.addModal.id, button)
				this.overlayBackgroundDisplay = true
				this.addModal.userLevel = '0.50'
				this.addModal.title = title
			})

		},
		// NS-10020 SP Adding pan principal access parameter
		openEditModal(title, userId, level, name, email, password, protectedUser, headUser, panPrincipalAccess, hashLogon, button) {
			this.$store.dispatch('endUsersAdminLogonsStore/getAddAdminUserData', {
				userLevel: this.$store.getters.getUserLevel
			}).then(() => {
				this.editModal.title = title
				this.editModal.userId = userId
				this.editModal.level = level			
				this.editModal.name = name
				this.editModal.email = email
				this.editModal.protectedUser = protectedUser
				this.editModal.headUser = headUser
				this.editModal.panPrincipalAccess = panPrincipalAccess // NS-10020 SP
				this.editModal.hashLogon = hashLogon
				this.overlayBackgroundDisplay = true
				this.$root.$emit('bv::show::modal', this.editModal.id, button)
			})
		},
    // NS-10020 SP request principals
    openEditPrincipalsModal(userId, title, button) {
      this.$store.dispatch('endUsersAdminLogonsStore/getUsersPrincipals', {
        userId: userId
      }).then(response => {
        this.editPrincipalsModal.userId = userId
        this.editPrincipalsModal.principals = response
        this.editPrincipalsModal.title = title
        this.overlayBackgroundDisplay = true

        this.$root.$emit('bv::show::modal',  this.editPrincipalsModal.id, button)
      })
    },
    resetEditPrincipalsModal() {
      this.editPrincipalsModal.userId = null
      this.editPrincipalsModal.principals = null
      this.editPrincipalsModal.title = ''

      this.$store.dispatch('alertClearResponse')
      this.overlayBackgroundDisplay = false
    },
    // NS-10020 SP request doc types
    openEditDocTypesModal(userId, title, button) {
      this.$store.dispatch('endUsersAdminLogonsStore/getAdminDocumentTypes', {
        userId: userId
      }).then(response => {
        this.editDocTypesModal.userId = userId
        this.editDocTypesModal.docTypes = response
        this.editDocTypesModal.title = title
        this.overlayBackgroundDisplay = true

        this.$root.$emit('bv::show::modal', this.editDocTypesModal.id, button)
      })
    },
    resetEditDocTypesModal() {
      this.editDocTypesModal.userId = null
      this.editDocTypesModal.docTypes = null
      this.editDocTypesModal.title = ''

      this.$store.dispatch('alertClearResponse')
      this.overlayBackgroundDisplay = false
    },
    resetaddModal() {
			this.addModal.title = ''
			this.addModal.userId = null
			this.addModal.userName= ''
			this.addModal.name = ''
			this.addModal.email = ''
			this.addModal.password = ''
			this.addModal.userLevel = null
			this.addModal.headUser = 0
			this.existingUserDetails = null
			this.overlayBackgroundDisplay = false
			this.userExists = false
			this.$store.state.endUsersAdminLogonsStore.existingUser = null
			this.$store.commit('alertClearErrors', null)
		},
		resetEditModal() {
			this.editModal.title = ''
			this.editModal.userId = null
			this.editModal.level = ''			
			this.editModal.name = ''
			this.editModal.email = ''
			this.editModal.password = ''
			this.editModal.protectedUser = 0
			this.editModal.headUser = 0
			this.editModal.hashLogon = 0
			this.overlayBackgroundDisplay = false
			this.$store.commit('alertClearErrors', null)
		},		
		addAdminUser() {
			this.$store.dispatch('endUsersAdminLogonsStore/addAdminUser', {
				userName: this.addModal.userName,
				name: this.addModal.name,
				email: this.addModal.email,
				password: this.addModal.password,
				userLevel: this.addModal.userLevel,
				headUser: this.addModal.headUser,
				currentUser: this.$store.getters.getUserDetails.id
			}).then(() => {
				if(this.getValidationErrors.userEmail == undefined && this.getValidationErrors.userPassword == undefined){
					this.existingUserDetails = this.$store.getters['endUsersAdminLogonsStore/getExistingUser']
					if(this.existingUserDetails != null) {
						this.userExists = true
						this.addModal.title = this.t('updateAdminUserModalTitle','updateAdminUserModalTitle')
					} else {
						this.existingUserDetails = null
						this.userExists = false
						this.$store.state.endUsersAdminLogonsStore.existingUser = null
						this.$root.$emit('bv::hide::modal', this.addModal.id)
						this.requestAdminUsersList()
					}
					
				}				
			})
		},
		editAdminUser() {
			this.$store.dispatch('endUsersAdminLogonsStore/editAdminUser', {
				userId: this.editModal.userId,
				name: this.editModal.name,
				email: this.editModal.email,
				level: this.editModal.level,
				password: this.editModal.password,
				protectedUser: this.editModal.protectedUser,
				headUser: this.editModal.headUser,
				hashLogon: this.editModal.hashLogon,
				currentUser: this.$store.getters.getUserDetails.id
			}).then(() => {
				this.requestAdminUsersList()
				if(this.getValidationErrors.userEmail == undefined && this.getValidationErrors.updatePassword == undefined){
					this.$root.$emit('bv::hide::modal', this.editModal.id)
				}
			})
		},		
		updateAdminUser() {
			this.$store.dispatch('endUsersAdminLogonsStore/updateAdminUserLevel', {
				userId: this.existingUserDetails.id,
				userLevel: this.addModal.userLevel
			}).then(() => {
				this.userExists = false
				this.existingUserDetails = null
				this.$root.$emit('bv::hide::modal', this.addModal.id)
				this.requestAdminUsersList()
				this.$store.state.endUsersAdminLogonsStore.existingUser = null
			})
		},
		editAccountStatus(event, data) {
			data.account_disabled = !data.account_disabled
			let account_status = 0
			if(data.account_disabled) {
				account_status = 1
			} else {
				account_status = 0
			}
			this.$store.dispatch('endUsersAdminLogonsStore/updateAdminAccountStatus', {
				userId: data.id,
				account_disabled: account_status,
				currentUser: this.$store.getters.getUserDetails.id
			})		
		},
		openEmailModal(title, userId, email, password, button) {
			this.emailModal.title = title
			this.emailModal.userId = userId
			this.$store.dispatch('endUsersAdminLogonsStore/getEndUserEmailDetails', {
				id: this.emailModal.userId 
			}).then(() => {
				this.emailModal.message = this.$store.getters['endUsersAdminLogonsStore/getEmailForm'].message
				this.emailModal.sendTo = this.$store.getters['endUsersAdminLogonsStore/getEmailForm'].email
				this.emailModal.subject = this.$store.getters['endUsersAdminLogonsStore/getEmailForm'].subject
				this.emailModal.from = this.$store.getters['endUsersAdminLogonsStore/getEmailForm'].from
				this.emailModal.password = this.$store.getters['endUsersAdminLogonsStore/getEmailForm'].password
				this.overlayBackgroundDisplay = true
				this.$root.$emit('bv::show::modal', this.emailModal.id, button)
			})
		},
		resetEmailModal() {
			this.emailModal.userId = null
			this.emailModal.title = ''
			this.emailModal.sendTo = ''
			this.emailModal.subject = ''
			this.emailModal.from = ''
			this.emailModal.message = ''
			this.overlayBackgroundDisplay = false
			this.$store.commit('alertClearErrors', null)
		},
		sendEmail() {
			this.$store.dispatch('endUsersAdminLogonsStore/sendEmailToUser', {
				userId: this.emailModal.userId,
				sendTo: this.emailModal.sendTo,
				from: this.emailModal.from,
				subject: this.emailModal.subject,
				password: this.emailModal.password,
				message: this.emailModal.message,
				component: 'adminUsers'
			}).then(() => {
				if(this.getValidationErrors.userEmail == undefined){
					this.$root.$emit('bv::hide::modal', this.emailModal.id)
				}
			})			
		},		
		resetDeleteModal() {
			this.deleteModal.title = ''
			this.deleteModal.userId = null
			this.deleteModal.email = ''
			this.overlayBackgroundDisplay = false
		},
		deleteAdminUser() {
			this.$store.dispatch('endUsersAdminLogonsStore/deleteAdminUser', {
				userId: this.deleteModal.userId,
				currentUser: this.$store.getters.getUserDetails.id
			}).then(() => {
				this.requestAdminUsersList()
				this.$root.$emit('bv::hide::modal', this.deleteModal.id)
			})			
		},
		openDeleteModal(title, userId, email, button) {
			this.deleteModal.title = title
			this.deleteModal.userId = userId
			this.deleteModal.email = email
			this.overlayBackgroundDisplay = true
			this.$root.$emit('bv::show::modal', this.deleteModal.id, button)
    },
    getUserLevelFilters() {
      this.$store.dispatch('endUsersAdminLogonsStore/getFilterUserLevels').then(response => {
        this.userLevelsFilter = response
      })
    },
    
    // NS-10082 - Display delete link when appropriate - DB - 23/04/2021
    displayDeleteLink(data) {
      return (this.getUserLevel > data.item.user_level && data.item.email_protected != 1) ? true : false
    },
	},
	computed: {
		...mapGetters(['getResponseInfo', 'getUserLevel', 'getUserDetails', 'getValidationErrors']),
		...mapGetters('endUsersAdminLogonsStore', ['getAdminUsers', 'getProtectedUser', 'getEmailForm', 'getAvailableUserLevls']),
    protectedUserEnabled() {
      return this.$store.getters['endUsersAdminLogonsStore/getProtectedUser']
    }
	},
  watch: {
    'currentPage'() {
      this.requestAdminUsersList()
    },
    'perPage'() {
      this.requestAdminUsersList()
    }
  }	
}
</script>

<style scoped>

  .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
	table >>> tbody, table >>> thead {
    text-align: center;
  }
	.text-netsend-blue {
    color: #047bf8;
  }
  .controls-below-table {
    align-items: center;
  }
</style>